import { NavLink } from "react-router-dom";
import { RiBuilding2Line } from "react-icons/ri";

export default function GroupLeaderMenu({ setToggleFalse }) {
  return (
    <ul>


      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/groupleader/groupleaderdashboard`}
        >
          <span className="icon icon-wysiwyg"></span>
          Dashboard
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/groupleader/jobseekers`}
        >
          <span className="icon icon-job-seeker"> </span> Sponsored Job Seekers
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/groupleader/supportteammembers`}
        >
          <span className="icon icon-support-members"></span> Support Team
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/groupleader/organization`}
        >
          <RiBuilding2Line className="custom-icon-size" />  Organization
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/groupleader/reportabuse`}
        >
          <span className="icon icon-documents"></span> Report Abuse
        </NavLink>
      </li>

      <li
        onClick={setToggleFalse}
        style={{
          margin: '40px 15px 10px 15px',
          padding: '8px 0',
          borderLeft: '5px solid #c3e6cb',
          borderRight: '5px solid #c3e6cb',
          borderRadius: '4px',
          background: 'rgb(212 237 218 / 8%)',
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)'
        }}
      >
        <NavLink
          to={`${process.env.PUBLIC_URL}/groupleader/tips`}
          style={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          <span>Tips To Get Started</span>
        </NavLink>
      </li>

    </ul>
  );
}
